import React, { useState, useEffect } from 'react'
import { settingsService } from '../../services/settingsService'

function Lingkungan() {
  const [lingkungan, setLingkungan] = useState([])
  const [cabang, setCabang] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [editing, setEditing] = useState(null)
  const [search, setSearch] = useState('')
  const [saving, setSaving] = useState(false)

  const [formData, setFormData] = useState({
    kodeLingkungan: '',
    namaLingkungan: '',
    kodeCabang: 'PUSAT',
    keterangan: ''
  })

  useEffect(() => {
    fetchLingkungan()
    fetchCabang()
  }, [search])

  const fetchCabang = async () => {
    try {
      const response = await settingsService.getCabang()
      setCabang(response.data.data || [])
    } catch (error) {
      console.error('Error fetching cabang:', error)
    }
  }

  const fetchLingkungan = async () => {
    try {
      setLoading(true)
      const response = await settingsService.getLingkungan({ search })
      setLingkungan(response.data.data || [])
    } catch (error) {
      console.error('Error fetching lingkungan:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const openCreate = () => {
    setEditing(null)
    setFormData({
      kodeLingkungan: '',
      namaLingkungan: '',
      kodeCabang: 'PUSAT',
      keterangan: ''
    })
    setShowModal(true)
  }

  const openEdit = (item) => {
    setEditing(item)
    setFormData({
      kodeLingkungan: item.KodeLingkungan,
      namaLingkungan: item.NamaLingkungan,
      kodeCabang: item.KodeCabang,
      keterangan: item.Keterangan || ''
    })
    setShowModal(true)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    try {
      if (editing) {
        await settingsService.updateLingkungan(editing.KodeLingkungan, {
          namaLingkungan: formData.namaLingkungan,
          kodeCabang: formData.kodeCabang,
          keterangan: formData.keterangan
        })
        alert('Lingkungan berhasil diupdate')
      } else {
        await settingsService.createLingkungan(formData)
        alert('Lingkungan berhasil dibuat')
      }
      setShowModal(false)
      fetchLingkungan()
    } catch (error) {
      alert(error.response?.data?.message || 'Gagal menyimpan data')
    } finally {
      setSaving(false)
    }
  }

  const handleDelete = async (kode) => {
    if (!confirm('Yakin ingin menghapus lingkungan ini?')) return
    try {
      await settingsService.deleteLingkungan(kode)
      alert('Lingkungan berhasil dihapus')
      fetchLingkungan()
    } catch (error) {
      alert(error.response?.data?.message || 'Gagal menghapus lingkungan')
    }
  }

  return (
    <div className="container-fluid">
      <div className="row mb-3">
        <div className="col-12">
          <h3><i className="fas fa-map-marked-alt mr-2"></i>Master Lingkungan / Area</h3>
          <p className="text-muted">Kelola kode wilayah untuk sistem NBA (Nomor Buku Anggota)</p>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h5 className="mb-0">Daftar Lingkungan</h5>
            </div>
            <div className="col-md-6 text-right">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Cari kode atau nama..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <div className="input-group-append">
                  <button className="btn btn-primary" onClick={openCreate}>
                    <i className="fas fa-plus mr-1"></i> Tambah
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-4">
              <i className="fas fa-spinner fa-spin fa-2x"></i>
              <p className="mt-2">Memuat data...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th>Kode Lingkungan</th>
                    <th>Nama Lingkungan</th>
                    <th>Kode Cabang</th>
                    <th>Keterangan</th>
                    <th className="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {(!lingkungan || !Array.isArray(lingkungan) || lingkungan.length === 0) ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        <div className="alert alert-light mb-0">
                          <i className="fas fa-info-circle mr-2"></i>
                          Tidak ada data lingkungan
                        </div>
                      </td>
                    </tr>
                  ) : (
                    lingkungan.map((item) => (
                      <tr key={item.KodeLingkungan}>
                        <td>
                          <span className="badge badge-primary">{item.KodeLingkungan}</span>
                        </td>
                        <td className="font-weight-bold">{item.NamaLingkungan}</td>
                        <td>{item.KodeCabang}</td>
                        <td>{item.Keterangan || '-'}</td>
                        <td className="text-center">
                          <button 
                            className="btn btn-sm btn-warning mr-1" 
                            onClick={() => openEdit(item)}
                            title="Edit"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button 
                            className="btn btn-sm btn-danger" 
                            onClick={() => handleDelete(item.KodeLingkungan)}
                            title="Hapus"
                            disabled={['UMUM', 'JKT', 'BDG', 'SBY'].includes(item.KodeLingkungan)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="card-footer bg-light">
          <small className="text-muted">
            <i className="fas fa-info-circle mr-1"></i>
            <strong>Format NBA:</strong> KODECABANG-KODELINGKUNGAN-NOMORURUT 
            (contoh: <code>PUSAT-JKT-000001</code>)
          </small>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  {editing ? 'Edit Lingkungan' : 'Tambah Lingkungan Baru'}
                </h5>
                <button type="button" className="close text-white" onClick={() => setShowModal(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="form-group">
                    <label>Kode Lingkungan *</label>
                    <input
                      type="text"
                      name="kodeLingkungan"
                      className="form-control"
                      value={formData.kodeLingkungan}
                      onChange={handleChange}
                      required
                      maxLength="10"
                      disabled={!!editing}
                      placeholder="Contoh: JKT, BDG, SBY"
                    />
                    <small className="form-text text-muted">
                      Kode unik untuk wilayah/area (max 10 karakter)
                    </small>
                  </div>

                  <div className="form-group">
                    <label>Nama Lingkungan *</label>
                    <input
                      type="text"
                      name="namaLingkungan"
                      className="form-control"
                      value={formData.namaLingkungan}
                      onChange={handleChange}
                      required
                      maxLength="100"
                      placeholder="Contoh: Jakarta, Bandung, Surabaya"
                    />
                  </div>

                  <div className="form-group">
                    <label>Kode Cabang *</label>
                    <select
                      name="kodeCabang"
                      className="form-control"
                      value={formData.kodeCabang}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Pilih Cabang --</option>
                      {cabang && Array.isArray(cabang) && cabang.map(c => (
                        <option key={c.KodeCabang} value={c.KodeCabang}>
                          {c.KodeCabang} - {c.NamaCabang}
                        </option>
                      ))}
                    </select>
                    <small className="form-text text-muted">
                      Cabang harus terdaftar di sistem
                    </small>
                  </div>

                  <div className="form-group">
                    <label>Keterangan</label>
                    <textarea
                      name="keterangan"
                      className="form-control"
                      rows="2"
                      value={formData.keterangan}
                      onChange={handleChange}
                      placeholder="Keterangan tambahan..."
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Batal
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? <i className="fas fa-spinner fa-spin mr-1"></i> : null}
                    {editing ? 'Update' : 'Simpan'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Lingkungan
